import Vue from 'vue'

import Template from './anmeldung.vue'

import { FormValidation, chain, required, valid_email } from '../form/form'

const password_secure = function (key: string) {
    return ( this.security === 'insecure' ? 'insecure' : '' )
}

const passwords_equal1 = function () {
    if (this.form['password'].trim()) { this.check('password2') }
    return ''
}

const passwords_equal2 = function () {
    return (this.form['password'].trim() === this.form['password2'] ? '' : 'unequal')
}

new Vue ({
    name: 'AnmeldungForm',
    el: '#app',
    data: {
        kwk_id: '',
    },
    extends: FormValidation(Template, {
        vorname      : chain('vorname',      required),
        name         : chain('name',         required),
        email        : chain('email',        required, valid_email),
        telefon      : () => {},
        benutzername : chain('benutzername', required),
        password     : chain('password',     passwords_equal1, required, password_secure),
        password2    : chain('password2',    required, passwords_equal2),
        datenschutz  : chain('datenschutz',  required),
    }),
    mounted() {
        let path = window.location.pathname;
        if (path.includes('/kwk/')) {
            if (path.split('/')[3]) {
                this.$data.kwk_id = path.split('/')[3];
            }
        }
    },
    methods: {
        post_error() {
            if (this.errors.password2 === 'unequal') {
                this.form.password  = ''
                this.form.password2 = ''
            }
        }
    },
    computed: {
        security() {
            const pw = this.form.password.trim()

            // INSECURE
            if (pw.length < 3) { return 'insecure' }
            if (! /[a-z]/.test(pw)) { return 'insecure' }
            if (! /[A-Z]/.test(pw)) { return 'insecure' }
            if (! /[^a-zA-Z]/.test(pw)) { return 'insecure' }

            // WEAK: 3+ chars, 1x[a-z], 1x[A-Z], 1x([0-9] or Special)
            if (pw.length < 8) { return 'weak' }

            // OKAY: 8+ chars, 1x[a-z], 1x[A-Z], 1x[0-9] and 1xSpecial
            if (pw.length < 20) { return 'okay' }
            if (pw.replace(/[^a-z]/g, '').length < 2) { return 'okay' }
            if (pw.replace(/[^A-Z]/g, '').length < 2) { return 'okay' }
            if (pw.replace(/[^0-9]/g, '').length < 2) { return 'okay' }
            if (pw.replace(/[a-zA-Z0-9]/g, '').length < 2) { return 'okay' }

            // SECURE: 20+ chars, 2x[a-z], 2x[A-Z], 2x[0-9] and 2xSpecial
            return 'secure'
        },
    },
})
